var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 21.548C41.9873 26.9808 39.8185 32.1864 35.9702 36.0212C32.1219 39.856 26.9089 42.0063 21.4761 42C16.0433 41.9936 10.8352 39.831 6.99585 35.9872C3.15654 32.1434 0.999999 26.9328 0.999998 21.5001C0.999998 16.0673 3.15654 10.8565 6.99585 7.01274C10.8352 3.16894 16.0433 1.00641 21.4761 1.00005C26.9088 0.993687 32.1219 3.14413 35.9702 6.97893C39.8185 10.8137 41.9873 16.0192 42 21.452L42 21.548Z",
    stroke: "#DEDFE3",
    strokeWidth: 1.90698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4579 20.9482L23.2098 15.1962C23.343 15.063 23.5236 14.9883 23.7119 14.9883C23.9002 14.9883 24.0807 15.063 24.2139 15.1962L24.8849 15.8662C25.0181 15.9992 25.0931 16.1798 25.0933 16.368C25.0934 16.5563 25.0189 16.737 24.8859 16.8702L20.3279 21.4502L24.8859 26.0302C25.0187 26.1633 25.0933 26.3437 25.0933 26.5317C25.0933 26.7198 25.0187 26.9001 24.8859 27.0332L24.2139 27.7032C24.0807 27.8364 23.9002 27.9111 23.7119 27.9111C23.5236 27.9111 23.343 27.8364 23.2098 27.7032L17.4579 21.9532C17.3918 21.8873 17.3393 21.8089 17.3036 21.7227C17.2678 21.6364 17.2495 21.544 17.2495 21.4507C17.2495 21.3573 17.2678 21.2649 17.3036 21.1787C17.3393 21.0925 17.3918 21.0142 17.4579 20.9482Z",
    fill: "#DEDFE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBtn);
export default __webpack_public_path__ + "static/media/LeftBtn.02fa622f476d2d63b269f6fd75f9e23e.svg";
export { ForwardRef as ReactComponent };